import React, { useState } from "react";
import { Link } from "react-router-dom";
import { BsPeople } from "react-icons/bs";
import { FaCheck } from "react-icons/fa";
import { formatPrice } from "../../utils/formatPrice";

const dayTypeLabels = {
  WEEKDAY: "LUNES A JUEVES",
  WEEKEND: "VIERNES A DOMINGO",
  ANY: "CUALQUIER DIA",
};

const PackageCard = ({ pkg }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const {
    id,
    name,
    subtitle,
    days,
    nights,
    dayType,
    accommodationLabel,
    includedServices,
    maxPersons,
    price,
    originalPrice,
    backgroundImage,
  } = pkg;

  return (
    <div className="relative overflow-hidden shadow-2xl group h-full flex flex-col">
      {/* Background image with dark overlay */}
      <div className="absolute inset-0">
        {!imageLoaded && backgroundImage && (
          <div className="absolute inset-0 bg-gray-800 animate-pulse" />
        )}
        {backgroundImage ? (
          <img
            src={backgroundImage}
            alt={`Paquete ${name} - Estancia La Alameda`}
            className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 ${
              imageLoaded ? "opacity-100" : "opacity-0"
            }`}
            loading="lazy"
            decoding="async"
            onLoad={() => setImageLoaded(true)}
          />
        ) : (
          <div className="w-full h-full bg-gradient-to-br from-gray-800 to-gray-900" />
        )}
        <div className="absolute inset-0 bg-black/60 group-hover:bg-black/50 transition-colors duration-300" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col h-full p-6 text-white">
        {/* Badges */}
        <div className="flex flex-wrap gap-2 mb-4">
          <span className="bg-accent/90 text-white text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wider">
            {days} DIAS / {nights} {nights === 1 ? "NOCHE" : "NOCHES"}
          </span>
          {dayType !== "ANY" && (
            <span className="bg-white/20 text-white text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wider backdrop-blur-sm">
              {dayTypeLabels[dayType]}
            </span>
          )}
        </div>

        {/* Name */}
        <h3 className="text-2xl font-bold font-primary mb-1">{name}</h3>
        {subtitle && (
          <p className="text-white/70 text-sm mb-4">{subtitle}</p>
        )}

        {/* Accommodation label */}
        {accommodationLabel && (
          <p className="text-accent font-tertiary uppercase tracking-[2px] text-xs mb-4">
            {accommodationLabel}
          </p>
        )}

        {/* Services */}
        {includedServices && includedServices.length > 0 && (
          <ul className="space-y-1.5 mb-4">
            {includedServices.map((service, index) => (
              <li key={index} className="flex items-center gap-2 text-sm text-white/90">
                <FaCheck className="text-accent text-xs flex-shrink-0" />
                {service}
              </li>
            ))}
          </ul>
        )}

        {/* Persons */}
        <div className="flex items-center gap-2 text-sm text-white/80 mb-4">
          <BsPeople className="text-accent" />
          <span>Hasta {maxPersons} {maxPersons === 1 ? "persona" : "personas"}</span>
        </div>

        {/* Price */}
        <div className="mt-auto">
          <div className="flex items-end gap-2 mb-4">
            {originalPrice && originalPrice > price && (
              <span className="text-white/50 line-through text-lg">
                ${formatPrice(originalPrice)}
              </span>
            )}
            <span className="text-3xl font-bold text-white">
              ${formatPrice(price)}
            </span>
          </div>

          {/* CTA Button */}
          <Link
            to={`/paquetes/${id}`}
            className="btn btn-secondary btn-sm w-full"
          >
            Reserva tu escapada
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PackageCard;
